import { render, staticRenderFns } from "./StaticIntroButton.vue?vue&type=template&id=1821d2de&scoped=true&"
import script from "./StaticIntroButton.vue?vue&type=script&lang=js&"
export * from "./StaticIntroButton.vue?vue&type=script&lang=js&"
import style0 from "./StaticIntroButton.vue?vue&type=style&index=0&id=1821d2de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1821d2de",
  null
  
)

export default component.exports